import { render, staticRenderFns } from "./TheMessage.vue?vue&type=template&id=f8655bc6&scoped=true"
import script from "./TheMessage.vue?vue&type=script&lang=js"
export * from "./TheMessage.vue?vue&type=script&lang=js"
import style0 from "./TheMessage.vue?vue&type=style&index=0&id=f8655bc6&prod&lang=css"
import style1 from "./TheMessage.vue?vue&type=style&index=1&id=f8655bc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8655bc6",
  null
  
)

export default component.exports